import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import PrimaryButton from '../Button/PrimaryButton';

const drawerWidth = 400;

const drawerStyle = {
    width: drawerWidth,
    flexShrink: 0,
    '& .MuiDrawer-paper': {
        width: drawerWidth,
        boxSizing: 'border-box',
        padding: '20px',
    },
};

export default function TemporaryDrawer({ 
    anchor = 'right',
    open = false,
    onClose,
    children,
    className
}) {
    return (
        <Drawer
            className={className}
            anchor={anchor}
            open={open}
            onClose={onClose}
            sx={drawerStyle}
        >
            {children}
        </Drawer>
    );
}
